import { Box, Grid, GridItem, Heading, Link, SimpleGrid, Text, Container, Modal, ModalOverlay, ModalContent, ModalBody, IconButton, Flex, useDisclosure, ModalCloseButton, Image } from "@chakra-ui/react";
import React, { useState } from "react";
import parser from "html-react-parser";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";

const ImagesGridBlock = ({ page, block }) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const handleImageClick = (index) => {
        setCurrentImageIndex(index);
        onOpen();
    };

    const handlePrevious = () => {
        setCurrentImageIndex((prev) => 
            prev === 0 ? block.entry.images.length - 1 : prev - 1
        );
    };

    const handleNext = () => {
        setCurrentImageIndex((prev) => 
            prev === block.entry.images.length - 1 ? 0 : prev + 1
        );
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            onClose();
        } else if (e.key === 'ArrowLeft') {
            handlePrevious();
        } else if (e.key === 'ArrowRight') {
            handleNext();
        }
    };

    const currentImage = block.entry.images?.[currentImageIndex];

    return (
        <Box className="category-wrapper" pt={10} backgroundImage={`url(${block.bgimg})`} backgroundPosition="center center" backgroundSize="cover">
            <Container maxW={'6xl'}>
                {block.title != null ? (
                <Box className="experiences-header" pb={10}>
                    <Heading
                        as={'h2'}
                        fontSize={{ base: '3xl', sm: '4xl', md: '6xl' }}
                        textAlign={{ base: 'center', md: 'center' }}
                        lineHeight={'110%'}
                        color="#17325B">
                        {block.title}
                    </Heading>
                    {block.entry.content != null ? (
                        <Text className="content-block" textAlign={{ base: 'center', md: 'center' }}>
                            {parser(block.entry.content)}
                        </Text>
                    ) : null}
                </Box>
                ) : null}
                <Box pb={10}>
                    <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={5}>
                        {block.entry.images?.map((entry, index) => (
                            <Box key={index}>
                                {entry.link ? (
                                    <Link href={entry.link} target="_blank" _hover={{ opacity: 0.8 }} transition="opacity 0.2s" w="100%" h="100%">
                                        <Box 
                                            backgroundImage={`url(${entry.img})`} 
                                            backgroundPosition="center center" 
                                            backgroundSize="cover" 
                                            minHeight={{ base: "355px", md: "350px", lg: "225px" }} 
                                            position="relative"
                                        >
                                            {entry.title != null ? (
                                                <Heading textAlign="left" position="absolute" bottom="10px" left="20px" color="white" textShadow="0px 0px 5px #000" lineHeight="1em">{entry.title}</Heading>
                                            ) : null}
                                            {entry.subtitle != null ? (
                                                <Text fontSize="2xl" textAlign="left" position="absolute" top="10px" left="20px" color="white">{entry.subtitle}</Text>
                                            ) : null}
                                        </Box>
                                    </Link>
                                ) : (
                                    <Box 
                                        as="button"
                                        onClick={() => handleImageClick(index)}
                                        cursor="pointer"
                                        _hover={{ opacity: 0.8 }}
                                        transition="opacity 0.2s"
                                        w="100%"
                                        h="100%"
                                    >
                                        <Box 
                                            backgroundImage={`url(${entry.img})`} 
                                            backgroundPosition="center center" 
                                            backgroundSize="cover" 
                                            minHeight={{ base: "355px", md: "350px", lg: "225px" }} 
                                            position="relative"
                                        >
                                            {entry.title != null ? (
                                                <Heading textAlign="left" position="absolute" bottom="10px" left="20px" color="white" textShadow="0px 0px 5px #000" lineHeight="1em">{entry.title}</Heading>
                                            ) : null}
                                            {entry.subtitle != null ? (
                                                <Text fontSize="2xl" textAlign="left" position="absolute" top="10px" left="20px" color="white">{entry.subtitle}</Text>
                                            ) : null}
                                        </Box>
                                    </Box>
                                )}
                            </Box>
                        ))}
                    </SimpleGrid>
                </Box>
            </Container>

            {/* Lightbox Modal */}
            <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered>
                <ModalOverlay bg="blackAlpha.800" />
                <ModalContent bg="transparent" boxShadow="none" maxW="90vw" maxH="90vh">
                    <ModalCloseButton 
                        color="white" 
                        bg="blackAlpha.500" 
                        borderRadius="full"
                        _hover={{ bg: "blackAlpha.700" }}
                        zIndex={10}
                    />
                    <ModalBody p={0} position="relative" onKeyDown={handleKeyDown} tabIndex={0}>
                        <Box position="relative" w="100%" h="100%">
                            {currentImage && (
                                <Image
                                    src={currentImage.img}
                                    alt={currentImage.title || `Gallery image ${currentImageIndex + 1}`}
                                    w="100%"
                                    h="100%"
                                    objectFit="contain"
                                    maxH="90vh"
                                />
                            )}
                            
                            {/* Navigation Arrows */}
                            {block.entry.images?.length > 1 && (
                                <>
                                    <IconButton
                                        aria-label="Previous image"
                                        icon={<MdChevronLeft />}
                                        onClick={handlePrevious}
                                        position="absolute"
                                        left={4}
                                        top="50%"
                                        transform="translateY(-50%)"
                                        bg="blackAlpha.500"
                                        color="white"
                                        _hover={{ bg: "blackAlpha.700" }}
                                        borderRadius="full"
                                        size="lg"
                                    />
                                    <IconButton
                                        aria-label="Next image"
                                        icon={<MdChevronRight />}
                                        onClick={handleNext}
                                        position="absolute"
                                        right={4}
                                        top="50%"
                                        transform="translateY(-50%)"
                                        bg="blackAlpha.500"
                                        color="white"
                                        _hover={{ bg: "blackAlpha.700" }}
                                        borderRadius="full"
                                        size="lg"
                                    />
                                </>
                            )}
                            
                            {/* Image Info */}
                            {(currentImage?.title || currentImage?.subtitle) && (
                                <Box
                                    position="absolute"
                                    bottom={4}
                                    left="50%"
                                    transform="translateX(-50%)"
                                    bg="blackAlpha.700"
                                    color="white"
                                    px={6}
                                    py={3}
                                    borderRadius="md"
                                    textAlign="center"
                                    maxW="80%"
                                >
                                    {currentImage.title && (
                                        <Heading size="md" mb={1}>
                                            {currentImage.title}
                                        </Heading>
                                    )}
                                    {currentImage.subtitle && (
                                        <Text fontSize="lg">
                                            {currentImage.subtitle}
                                        </Text>
                                    )}
                                </Box>
                            )}

                            {/* Image Counter */}
                            {block.entry.images?.length > 1 && (
                                <Box
                                    position="absolute"
                                    top={4}
                                    left="50%"
                                    transform="translateX(-50%)"
                                    bg="blackAlpha.500"
                                    color="white"
                                    px={4}
                                    py={2}
                                    borderRadius="full"
                                    fontSize="sm"
                                >
                                    {currentImageIndex + 1} / {block.entry.images.length}
                                </Box>
                            )}
                        </Box>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </Box>
    )
};

export default ImagesGridBlock;